export default "__VITE_ASSET__D48E4x6x__"